// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__6vW5j","label":"CategoryService_label__2oGFZ","location":"CategoryService_location__3SNhD"};